module.exports = __webpack_public_path__ + "img/btn_menu_yj_c.4d0ac596.png";